<template>
    <a href="#" :class="stylesClass" title="Checkout" @click="buyItem">{{text}}</a>
</template>

<script>
    import {bus} from '../../bus'
    export default {
        props: [
            'product',
            'stylesClass',
            'text'
        ],
        data() {
            return {
            }
        },
        methods: {
            buyItem(e) {
                e.preventDefault()
                let productSave = {
                    id: this.product.id,
                    name: this.product.name,
                    quantity: 1,
                    comment: this.product.comment || ''
                }
                let items = JSON.parse(localStorage.getItem('items')) || []
                // checking if the product exists into items
                // console.log(items);
                let productFound = false
                items.forEach(item => {
                    if (item.id == productSave.id) {
                        item.quantity += 1
                        productFound = true
                    }
                })
                // if doesn't exist should push one
                if (!productFound) {
                    items.push(productSave)

                    fetch("/api/update-popularity", {
                      method: "post",
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      //make sure to serialize your JSON body
                      body: JSON.stringify({
                        pid: productSave.id
                      })
                    })
                    .then( (response) => {
                       //do something awesome that makes the world a better place
                    });

                }
                localStorage.setItem('items', JSON.stringify(items))
                localStorage.setItem('payment_gateway', 2)
                bus.$emit('cart-was-updated')

                gtag("event", "add_to_cart", {
                  currency: "USD",
                  value: this.product.sale_price,
                  items: [
                    {
                      item_id: this.product.productCode,
                      item_name: this.product.name,
                      affiliation: "CarComputerExchange",
                      // coupon: "",
                      discount: this.product.save_price,
                      index: 0,
                      item_brand: this.product.maker,
                      item_category: this.product.category.name,
                      item_list_id: this.product.category.name + '_' + this.product.category.id,
                      item_list_name: this.product.category.name,
                      price: this.product.sale_price,
                      quantity: 1
                    }
                  ]
                });

                location.href = '/cart.php?act=step2'
            }
        },
        mounted() {
        }
    }
</script>
